// extracted by mini-css-extract-plugin
module.exports = {"body":"StaticPage_body__J_sGj","heading":"StaticPage_heading__NGBah","date":"StaticPage_date__yHb7J","author":"StaticPage_author__bvOOQ"};